<template>
    <div class="content">
        <toolbar v-bind:selection="toolbar" title="Colmenares" />

        <colmenares />

        <menubottom active="1" />

    </div>

</template>


<script>
import auth from "@/libs/auth"

import toolbar from "@/components/Toolbar"
import menubottom from "@/components/MenuBottom"
import colmenares from "@/components/Colmenares"

export default {
  name: 'app',
  components: {menubottom,toolbar,colmenares},

  data: () => ({

      toolbar: {
        return: '',
        icons: [
          { text: 'Añadir', href:'colmenar-nuevo' },
          { text: 'Cancelar', href:'colmenares' }
        ],
      }
  }),

  created() {
    auth.getUserLogged()
  }

}
</script>

<style scoped lang="scss">
</style>